import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { TSS_DARK_BLUE, UserShape, CompanyShape, childrenPropType } from 'tss-core-lib-common';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import Icon from 'react-svg-ikon';
import Hamburger from './hamburger.js';

import { IMG_TSS_LOGO, IMG_ICON_FEMALE_USER, IMG_ICON_CHEVRON_DOWN } from '../../img';
import { HEADER_HEIGHT } from '../../dimensions';
import clickOutsideEnhancer from '../clickOutsideEnhancer';
import withRefs from '../withRefsEnhancer';
import HeaderInfo from './HeaderInfo';

var styles = void 0;

var enhance = compose(withState('menuOpen', 'setMenuOpen', false), withHandlers({
  onContainerClick: function onContainerClick(props) {
    return function () {
      return props.setMenuOpen(!props.menuOpen);
    };
  },
  onClickOutside: function onClickOutside(props) {
    return function (event) {
      var container = props.getRef('userContainer');
      if (container && event.target !== container && !container.contains(event.target)) {
        setTimeout(function () {
          return props.setMenuOpen(false);
        }, 50);
      }
    };
  }
}));

var Header = function Header(_ref) {
  var children = _ref.children,
      user = _ref.user,
      menuOpen = _ref.menuOpen,
      setRef = _ref.setRef,
      systemInfo = _ref.systemInfo,
      toggleMenu = _ref.toggleMenu,
      onChangePasswordClick = _ref.onChangePasswordClick,
      onContainerClick = _ref.onContainerClick,
      mySettingLink = _ref.mySettingLink,
      passwordLink = _ref.passwordLink,
      onLogout = _ref.onLogout,
      applicationVersion = _ref.applicationVersion;
  return React.createElement(
    'div',
    { className: css(styles.container) },
    React.createElement(
      'div',
      { className: css(styles.logoContainer) },
      toggleMenu ? React.createElement(
        'div',
        { onClick: toggleMenu, style: { cursor: 'pointer', zIndex: '3000' }, onKeyPress: toggleMenu },
        React.createElement(Hamburger, null)
      ) : null,
      React.createElement(
        NavLink,
        { to: '/' },
        React.createElement('img', { src: IMG_TSS_LOGO, alt: 'TSS Logo' })
      )
    ),
    React.createElement(
      'div',
      { className: css(styles.headerInfoContainer) },
      children ? React.createElement(
        'div',
        { className: css(styles.actionBar) },
        children
      ) : React.createElement(HeaderInfo, Object.assign({
        key: 'info',
        timezone: user ? user.timezone : null,
        tvnId: user ? user.companyTvnId : null,
        ccisVersion: user ? user.ccisVersion : null,
        applicationVersion: applicationVersion,
        ip: user ? user.externalIp : null
      }, systemInfo)),
      ','
    ),
    user ? React.createElement(
      'div',
      {
        className: css(styles.userContainer),
        ref: setRef('userContainer'),
        onClick: onContainerClick,
        onKeyPress: onContainerClick,
        role: 'button',
        tabIndex: 0
      },
      React.createElement(
        'div',
        { key: 'userdetails', className: css(styles.userDetails) },
        React.createElement(
          'div',
          { className: css(styles.username) },
          user ? user.fullName : null
        ),
        React.createElement(
          'div',
          { className: css(styles.userWork) },
          user ? user.companyName : null
        ),
        React.createElement(
          'div',
          { className: css(styles.userWork) },
          user ? user.officeName : null
        )
      ),
      React.createElement(
        'div',
        { key: 'avatar', className: css(styles.userAvatar) },
        React.createElement(Icon, { src: IMG_ICON_FEMALE_USER, stroke: 'white' })
      ),
      React.createElement(Icon, { key: 'icon', src: IMG_ICON_CHEVRON_DOWN, className: 'arrow-down stroke ' + css(styles.arrowDown) }),
      ',',
      menuOpen ? React.createElement(
        'ul',
        { className: css(styles.userMenuContainer) },
        mySettingLink ? React.createElement(
          'li',
          null,
          React.createElement(
            'a',
            { href: mySettingLink, className: css(styles.logoutLink) },
            React.createElement(FormattedMessage, { id: 'header.my.settings' })
          )
        ) : null,
        passwordLink && !onChangePasswordClick ? React.createElement(
          'li',
          null,
          React.createElement(
            'a',
            { href: passwordLink, className: css(styles.logoutLink) },
            React.createElement(FormattedMessage, { id: 'header.change.password' })
          )
        ) : null,
        onChangePasswordClick && !passwordLink ? React.createElement(
          'li',
          null,
          React.createElement(
            'div',
            { onClick: onChangePasswordClick, className: css(styles.logoutLink), onKeyPress: onChangePasswordClick },
            React.createElement(FormattedMessage, { id: 'header.change.password' })
          )
        ) : null,
        React.createElement(
          'li',
          null,
          onLogout ? React.createElement(
            'a',
            { href: '#', onClick: function onClick() {
                return onLogout();
              }, className: css(styles.logoutLink) },
            React.createElement(FormattedMessage, { id: 'label.logout' })
          ) : React.createElement(
            'a',
            { href: '/logout', className: css(styles.logoutLink) },
            React.createElement(FormattedMessage, { id: 'label.logout' })
          )
        )
      ) : null
    ) : null
  );
};

Header.propTypes = {
  children: childrenPropType,
  user: UserShape,
  company: CompanyShape,
  systemInfo: PropTypes.shape({
    timezone: PropTypes.string,
    ip: PropTypes.string,
    host: PropTypes.string,
    os: PropTypes.string,
    browser: PropTypes.string,
    ccisVersion: PropTypes.string
  }).isRequired,
  menuOpen: PropTypes.bool.isRequired,
  setRef: PropTypes.func.isRequired,
  onContainerClick: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func,
  onChangePasswordClick: PropTypes.func,
  mySettingLink: PropTypes.string,
  passwordLink: PropTypes.string,
  applicationVersion: PropTypes.string,
  onLogout: PropTypes.func
};

Header.defaultProps = {
  children: null,
  user: null,
  company: null,
  toggleMenu: null,
  onChangePasswordClick: null,
  mySettingLink: null,
  passwordLink: null,
  onLogout: null,
  applicationVersion: null
};

styles = StyleSheet.create({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: HEADER_HEIGHT,
    backgroundColor: TSS_DARK_BLUE,
    display: 'flex',
    alignItems: 'stretch',
    zIndex: 50
  },

  logoContainer: {
    position: 'relative',
    top: '-0.45rem',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 2.3rem'
  },

  userContainer: {
    outline: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '0 2.3rem 0 0',
    cursor: 'pointer',
    position: 'relative',
    ':hover .arrow-down': {
      opacity: 1
    }
  },

  headerInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 3rem 0 0'
  },

  userMenuContainer: {
    position: 'absolute',
    outline: 0,
    top: '100%',
    left: 0,
    right: 0,
    margin: '2px 0 0 0',
    padding: 0,
    listStyleType: 'none',
    backgroundColor: 'white',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.3)'
  },

  logoutLink: {
    display: 'block',
    textDecoration: 'none',
    padding: '1.6rem',
    margin: 0,
    fontSize: '1.6rem',
    color: TSS_DARK_BLUE()
  },

  userMenuItem: {
    cursor: 'pointer',
    padding: '1.6rem',
    margin: 0,
    fontSize: '1.6rem',
    color: TSS_DARK_BLUE()
  },

  userAvatar: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    border: 0,
    borderRadius: '50%',
    width: '4.8rem',
    height: '4.8rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 1rem 0 1.1rem'
  },

  arrowDown: {
    color: 'white',
    opacity: 0.5,
    transition: 'opacity 0.2s linear'
  },

  userDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    color: 'white'
  },

  username: {
    fontSize: '1.2rem',
    fontWeight: 600,
    margin: '0.3rem 0'
  },

  userWork: {
    fontSize: '1.2rem',
    margin: '0.3rem 0',
    opacity: 0.6
  }
});

export default withRefs(enhance(clickOutsideEnhancer(Header, 'onClickOutside')));